<template>
  <div id="app">
    <section>
      <router-link class="logo" :to="{ name: 'home' }">{{
        site.title
      }}</router-link>
    </section>
    <navigation></navigation>
    <aside
      id="artists"
      :class="{ show: $route.name == 'home' }"
      v-if="$route.name == 'home' || $route.name == 'artist'"
    >
      <div v-for="(artist, index) in site.artists" :key="index">
        <template v-if="artist.count > 0"
          ><router-link :to="{ name: 'artist', params: { id: artist.uid } }">{{
            artist.title
          }}</router-link></template
        >
        <template v-else>{{ artist.title }}</template>
      </div>
    </aside>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
const Navigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
export default {
  name: "App",
  metaInfo() {
    return {
      titleTemplate: "Larkin Erdmann" + " %s"
    };
  },
  components: {
    Navigation
  },
  computed: mapState(["site"]),
  created() {
    this.$store.dispatch("loadSite");
  }
};
</script>

<style lang="scss">
@import "node_modules/reset-css/sass/_reset";
@font-face {
  font-family: "Med";
  src: url("./assets/fonts/AkzidGroStdMed.WOFF") format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "MedIta";
  src: url("./assets/fonts/AkzidGroStdMedIta.WOFF") format("woff");
  font-weight: normal;
  font-style: normal;
}
@import "@/assets/css/defaults";
</style>
